import i18n, { init as initI18n, use as i18nextUse } from 'i18next'
import { initReactI18next } from 'react-i18next'
import es from '@/locales/es.json'

export const SUPPORTED_LANGUAGES = ['en', 'es', 'pt'] as const
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number]

export const LANGUAGE_STORAGE_KEY = 'app_language'

type LocaleModule = {
  default: Record<string, unknown>
}

const loadedLanguages = new Set<SupportedLanguage>(['es'])

const localeLoaders: Record<SupportedLanguage, () => Promise<LocaleModule>> = {
  en: () => import('@/locales/en.json') as Promise<LocaleModule>,
  es: async () => ({ default: es }),
  pt: () => import('@/locales/pt.json') as Promise<LocaleModule>,
}

export async function ensureLanguageResources(lang: SupportedLanguage): Promise<void> {
  if (loadedLanguages.has(lang)) return

  const module = await localeLoaders[lang]()
  i18n.addResourceBundle(lang, 'translation', module.default, true, true)
  loadedLanguages.add(lang)
}

i18nextUse(initReactI18next)

initI18n({
  resources: {
    es: { translation: es },
  },
  lng: 'es',
  fallbackLng: 'es',
  interpolation: {
    // React already escapes values
    escapeValue: false,
  },
})

export default i18n
